import type { BadgeColor } from '@ksyos/design-system';
import type { MedConsultAssessmentAdvice } from '@common/customControls/bariatrics';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { AdviesAan } from '@common/validation/customControls/bariPre/utils';
import type { IUseGetCaroPatient } from '@frontend/utils/hooks/useGetCaroPatient';
import { DietAndPsychAdvice, MdoReportAdvice } from '@common/customControls/bariatrics';
import { indicatieVerwijzingSectionTitle } from '@common/validation/customControls/bariPre/utils';

export const dietAndPsychAdviceWithColor: { color: BadgeColor; value: DietAndPsychAdvice }[] = [
    {
        color: 'green',
        value: DietAndPsychAdvice.include,
    },
    {
        color: 'orange',
        value: DietAndPsychAdvice.possible,
    },
    {
        color: 'red',
        value: DietAndPsychAdvice.exclude,
    },
];

export const adviesAanFields: { fieldKey: keyof AdviesAan; label: string }[] = [
    { fieldKey: 'advies_aan_patient', label: 'Advies aan patiënt' },
    { fieldKey: 'advies_aan_huisarts', label: 'Advies aan huisarts' },
    { fieldKey: 'advies_aan_chirurg', label: 'Advies aan chirurg' },
];

export const initialConclusieAanvullendData = {
    conclusie_aanvullend_diabetes_mellitus: false,
    conclusie_aanvullend_hydrochloorthiazide: false,
    conclusie_aanvullend_psychofarmaca: false,
    conclusie_aanvullend_roken: false,
};

export const initialIndicatieVoorVerwijzingData = {
    indicatie_voor_verwijzing_diabetes: false,
    indicatie_voor_verwijzing_hartfalen: false,
    indicatie_voor_verwijzing_hypertensie: false,
    indicatie_voor_verwijzing_medicatie: false,
    indicatie_voor_verwijzing_nefrologie: false,
    indicatie_voor_verwijzing_obesitas_specifiek: false,
    indicatie_voor_verwijzing_osteoporose: false,
    indicatie_voor_verwijzing_overig: false,
    indicatie_voor_verwijzing_overig_toelichting: null,
};

export function bariPreIndicatieVoorVerwijzingReadSectionsTransformer(
    readSections: IProcessActivityReadSection[]
): IProcessActivityReadSection[] {
    const sectionIndex = readSections.findIndex((section) => section.sectionTitle === indicatieVerwijzingSectionTitle);
    if (sectionIndex === -1 || readSections[sectionIndex].items.some((item) => item.value !== null)) {
        return readSections;
    }

    return readSections.filter((section) => section.sectionTitle !== indicatieVerwijzingSectionTitle);
}

export function adviceValueIsDisabled(
    value: MdoReportAdvice | MedConsultAssessmentAdvice,
    caroPatient: IUseGetCaroPatient
): boolean {
    if (caroPatient.isLoading) {
        return true;
    }

    return !caroPatient.hasActivatedAccount && value === MdoReportAdvice.include;
}
